var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "shortcutComponent",
    {
      ref: "shortcutComponent",
      attrs: { showAddNew: false, modalClass: "ss-modal" },
      on: { "selection-item": _vm.save, "hide-click": _vm.hide },
    },
    [
      _c("div", { attrs: { slot: "component" }, slot: "component" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.save($event)
              },
            },
          },
          [
            _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "alert alert-warning",
                      attrs: { role: "alert" },
                    },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "senhaUsuario",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticClass: "color-red" }, [_vm._v("*")]),
                        _vm._v(
                          "\n                                Senha\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    (_vm.isOpened ? "password" : "text") === "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.senhaUsuario,
                              expression: "senhaUsuario",
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            autofocus: "",
                            autocomplete: "off",
                            id: "senhaUsuario",
                            name: "senhaUsuario",
                            type: "checkbox",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.senhaUsuario)
                              ? _vm._i(_vm.senhaUsuario, null) > -1
                              : _vm.senhaUsuario,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.senhaUsuario,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.senhaUsuario = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.senhaUsuario = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.senhaUsuario = $$c
                              }
                            },
                          },
                        })
                      : (_vm.isOpened ? "password" : "text") === "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.senhaUsuario,
                              expression: "senhaUsuario",
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            autofocus: "",
                            autocomplete: "off",
                            id: "senhaUsuario",
                            name: "senhaUsuario",
                            type: "radio",
                          },
                          domProps: { checked: _vm._q(_vm.senhaUsuario, null) },
                          on: {
                            change: function ($event) {
                              _vm.senhaUsuario = null
                            },
                          },
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.senhaUsuario,
                              expression: "senhaUsuario",
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            autofocus: "",
                            autocomplete: "off",
                            id: "senhaUsuario",
                            name: "senhaUsuario",
                            type: _vm.isOpened ? "password" : "text",
                          },
                          domProps: { value: _vm.senhaUsuario },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.senhaUsuario = $event.target.value
                            },
                          },
                        }),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }